
import { genreList, venueFilterList } from '../../../mocks/scheduleData';

interface ScheduleFiltersProps {
  selectedMonth: string;
  onMonthChange: (month: string) => void;
  selectedGenre: string;
  onGenreChange: (genre: string) => void;
  selectedVenue: string;
  onVenueChange: (venue: string) => void;
  searchQuery: string;
  onSearchChange: (query: string) => void;
  resultCount: number;
}

const months = [
  { value: '2025-07', label: '2025年7月' },
  { value: '2025-08', label: '2025年8月' },
];

export default function ScheduleFilters({
  selectedMonth,
  onMonthChange,
  selectedGenre,
  onGenreChange,
  selectedVenue,
  onVenueChange,
  searchQuery,
  onSearchChange,
  resultCount,
}: ScheduleFiltersProps) {
  return (
    <div className="space-y-6">
      {/* Month Tabs */}
      <div className="flex items-center justify-between flex-wrap gap-4">
        <div className="inline-flex bg-gray-100 rounded-full p-1">
          {months.map((m) => (
            <button
              key={m.value}
              onClick={() => onMonthChange(m.value)}
              className={`px-5 py-2 rounded-full text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                selectedMonth === m.value
                  ? 'bg-gray-900 text-white'
                  : 'text-gray-600 hover:text-gray-900'
              }`}
            >
              {m.label}
            </button>
          ))}
        </div>

        <div className="relative">
          <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 text-sm"></i>
          <input
            type="text"
            placeholder="アーティスト・公演名で検索"
            value={searchQuery}
            onChange={(e) => onSearchChange(e.target.value)}
            className="pl-9 pr-4 py-2 border border-gray-200 rounded-lg text-sm w-64 focus:outline-none focus:border-gray-400 transition-colors"
          />
        </div>
      </div>

      {/* Genre & Venue Filters */}
      <div className="flex flex-wrap items-center gap-3">
        <div className="flex items-center gap-2 mr-2">
          <i className="ri-music-2-line text-gray-400 text-sm w-4 h-4 flex items-center justify-center"></i>
          <span className="text-xs text-gray-500 font-medium">ジャンル</span>
        </div>
        <div className="flex flex-wrap gap-2">
          {genreList.map((genre) => (
            <button
              key={genre}
              onClick={() => onGenreChange(genre)}
              className={`px-3 py-1.5 rounded-full text-xs font-medium transition-colors whitespace-nowrap cursor-pointer ${
                selectedGenre === genre
                  ? 'bg-gray-900 text-white'
                  : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
              }`}
            >
              {genre}
            </button>
          ))}
        </div>
      </div>

      <div className="flex flex-wrap items-center gap-3">
        <div className="flex items-center gap-2 mr-2">
          <i className="ri-building-line text-gray-400 text-sm w-4 h-4 flex items-center justify-center"></i>
          <span className="text-xs text-gray-500 font-medium">会場</span>
        </div>
        <div className="flex flex-wrap gap-2">
          {venueFilterList.map((venue) => (
            <button
              key={venue}
              onClick={() => onVenueChange(venue)}
              className={`px-3 py-1.5 rounded-full text-xs font-medium transition-colors whitespace-nowrap cursor-pointer ${
                selectedVenue === venue
                  ? 'bg-gray-900 text-white'
                  : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
              }`}
            >
              {venue}
            </button>
          ))}
        </div>
      </div>

      <div className="flex items-center justify-between pt-2 border-t border-gray-100">
        <p className="text-sm text-gray-500">
          該当公演：<strong className="text-gray-900">{resultCount}</strong> 件
        </p>
        {(selectedGenre !== 'すべて' || selectedVenue !== 'すべて' || searchQuery) && (
          <button
            onClick={() => {
              onGenreChange('すべて');
              onVenueChange('すべて');
              onSearchChange('');
            }}
            className="text-xs text-gray-500 hover:text-gray-900 transition-colors cursor-pointer flex items-center gap-1"
          >
            <i className="ri-close-circle-line"></i>
            フィルターをリセット
          </button>
        )}
      </div>
    </div>
  );
}
